export default __webpack_public_path__ + "static/media/quote.59603850.svg";